import React from 'react';
import PropTypes from 'prop-types';

/**
 * Collapsible wrapper for long Integration Guide code blocks.
 * Collapsed by default (controlled): fade + icon-only chevron.
 */
const DocsCodePreview = ({ children, expanded, onToggle, label }) => (
  <div className={`docs-code-preview${expanded ? ' is-expanded' : ''}`}>
    {children}
    <button
      type="button"
      className={
        expanded ? 'docs-code-preview-collapse' : 'docs-code-preview-toggle'
      }
      onClick={onToggle}
      aria-expanded={expanded}
      aria-label={expanded ? `Collapse ${label}` : `Expand ${label}`}
    >
      {!expanded ? (
        <span className="docs-code-preview-fade" aria-hidden="true" />
      ) : null}
      <span className="docs-code-preview-icon" aria-hidden="true">
        <span
          className={`docs-code-preview-chevron${expanded ? ' is-up' : ''}`}
        />
      </span>
    </button>
  </div>
);

DocsCodePreview.propTypes = {
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default DocsCodePreview;
